/**
 * @internal
 */
import React, { createContext, useContext, useEffect, useState, } from 'react';
import useIsomorphicLayoutEffect from '@polestar/component-warehouse-react/hooks/useIsomorphicLayoutEffect';
import { passiveEventOptions } from '@polestar/component-warehouse-react/helpers/supports';
export var InteractionModes;
(function (InteractionModes) {
    InteractionModes["pointer"] = "pointer";
    InteractionModes["keyboard"] = "keyboard";
})(InteractionModes || (InteractionModes = {}));
export const InteractionContext = createContext({
    interactionMode: InteractionModes.pointer,
    setInteractionMode: () => 
    // eslint-disable-next-line no-console
    console.warn('[InteractionProvider] InteractionModeContext not set properly. Please make sure you wrap your app with PolestarApp.'),
    isKeyboardControlled: false,
});
export const useInteractionMode = () => {
    return useContext(InteractionContext);
};
const keyboardTriggerKeys = ['Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter'];
export const InteractionProvider = ({ children }) => {
    const [interactionMode, setInteractionMode] = useState(InteractionModes.pointer);
    const isKeyboardControlled = interactionMode === InteractionModes.keyboard;
    const [forcedKeyboardFocus, setForcedKeyboardFocus] = useState(false);
    // Move this to context
    useEffect(() => {
        const handleKeyboard = (e) => {
            if (!forcedKeyboardFocus &&
                (e.metaKey || e.altKey || e.ctrlKey || keyboardTriggerKeys.indexOf(e.key) === -1))
                return;
            setInteractionMode(InteractionModes.keyboard);
        };
        const handleMouse = () => {
            setInteractionMode(InteractionModes.pointer);
        };
        document.addEventListener('keydown', handleKeyboard, passiveEventOptions);
        document.addEventListener('mousedown', handleMouse, passiveEventOptions);
        document.addEventListener('touchstart', handleMouse, passiveEventOptions);
        document.addEventListener('wheel', handleMouse, passiveEventOptions);
        return () => {
            document.removeEventListener('keydown', handleKeyboard);
            document.removeEventListener('mousedown', handleMouse);
            document.removeEventListener('touchstart', handleMouse);
            document.removeEventListener('wheel', handleMouse);
        };
    }, [forcedKeyboardFocus]);
    useIsomorphicLayoutEffect(() => {
        document.body.dataset.interactionMode = interactionMode;
    }, [interactionMode]);
    return (React.createElement(InteractionContext.Provider, { value: { interactionMode, setInteractionMode, isKeyboardControlled, setForcedKeyboardFocus } }, children));
};
